import React from 'react';
import { CONFIRM_POPUP_CONTENT_WIDTH_CLASS } from '../../../../components/popup/popupLayoutSpec';
import {
  AdminPanelTitle,
  AdminHeaderAction,
  AdminFormSecondaryAction,
  AdminSupportingText,
} from '../../shared/adminUx';

/** Matches config SaveTestModal (e.g. AppealsDetail): X close + centered actions. */
const ConfigurationSaveTestModal = ({
  modal,
  onCancel,
  onRunTest,
  onSaveWithoutTest,
  title,
  message,
  confirmLabel,
  contentWidthClass = CONFIRM_POPUP_CONTENT_WIDTH_CLASS,
}) => {
  if (!modal) return null;

  const canTest = typeof onRunTest === 'function';
  const heading = title || 'Confirmation';
  const body =
    message ||
    (canTest ? 'You can test this rule before saving.' : 'Are you sure you want to save?');
  const primaryLabel = confirmLabel || 'Save';

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] px-4"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className={`bg-white rounded-xl shadow-lg ${contentWidthClass}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="relative px-5 pt-5 pb-3 border-b border-lightgray">
          <AdminPanelTitle className="text-offblack text-center">{heading}</AdminPanelTitle>
          <button
            type="button"
            onClick={onCancel}
            className="absolute right-4 top-4 text-offblack hover:text-primaryblue"
            aria-label="Close"
          >
            <i className="fi fi-rs-cross text-sm" aria-hidden />
          </button>
        </div>

        <div className="px-5 py-4">
          <AdminSupportingText className="text-offblack text-center">{body}</AdminSupportingText>
        </div>

        <div className="px-5 pb-5 flex flex-wrap justify-center gap-3">
          {canTest ? (
            <AdminFormSecondaryAction type="button" onClick={onRunTest}>
              Test Rule
            </AdminFormSecondaryAction>
          ) : (
            <AdminFormSecondaryAction type="button" onClick={onCancel}>
              Cancel
            </AdminFormSecondaryAction>
          )}
          <AdminHeaderAction type="button" onClick={onSaveWithoutTest}>
            {primaryLabel}
          </AdminHeaderAction>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationSaveTestModal;
